export default __webpack_public_path__ + "static/media/business-model-zoo-1.baa13c99.svg";